import styled from 'styled-components';
import { OrderToast } from './OrderToast';
import { useAppSelector } from '@/stores/hooks';

export const OrderToastContainer = () => {
  const items = useAppSelector((state) => state.toast.items);
  console.log('items', items);
  if (!items.length) return null;

  return (
    <Wrapper>
      {items.map((item) => (
        <OrderToast key={item.toastId} item={item} />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;
